var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GChart',{attrs:{"data":_vm.chartData,"type":'BarChart',"options":_vm.chartOptions,"width":600,"height":600}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }